import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiBookOpen, FiHeart, FiBell, FiStar, FiShield, FiArrowRight } = FiIcons;

const UserStatsOverview = () => {
  const stats = [
    { label: 'Memorials Managed', value: '3', icon: FiBookOpen, color: 'bg-accent-navy', textColor: 'text-white' },
    { label: 'Tributes Shared', value: '24', icon: FiHeart, color: 'bg-accent-gold', textColor: 'text-white' },
    { label: 'Unread Activity', value: '12', icon: FiBell, color: 'bg-brand-dark', textColor: 'text-accent-navy' },
    { label: 'Saved Legacies', value: '8', icon: FiStar, color: 'bg-brand-light', textColor: 'text-accent-gold' },
    { 
      label: 'Digital Estate Planning', 
      isPromo: true, 
      icon: FiShield, 
      color: 'bg-purple-50', 
      textColor: 'text-purple-600',
      link: '/resources?category=Estate Services',
      cta: 'Secure Legacy'
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 md:gap-6">
      {stats.map((stat, idx) => {
        if (stat.isPromo) {
          return (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: idx * 0.1 }}
              className="bg-gradient-to-br from-white to-purple-50/30 p-6 rounded-[32px] border-2 border-purple-100 shadow-sm hover:shadow-md transition-all group flex flex-col justify-between relative overflow-hidden"
            >
              <div className="absolute -right-4 -top-4 w-24 h-24 bg-purple-100/50 rounded-full blur-2xl group-hover:bg-purple-200/50 transition-colors" />
              
              <div>
                <div className={`w-12 h-12 ${stat.color} ${stat.textColor} rounded-2xl flex items-center justify-center mb-4 shadow-sm group-hover:rotate-12 transition-transform border border-purple-200`}>
                  <SafeIcon icon={stat.icon} className="w-6 h-6" />
                </div>
                <h3 className="text-sm font-bold text-accent-navy mb-1 leading-tight">{stat.label}</h3>
                <p className="text-[10px] text-text-muted font-medium mb-4">Protect your digital assets & legal documentation.</p>
              </div>

              <Link 
                to={stat.link}
                className="inline-flex items-center gap-2 text-[10px] font-black uppercase tracking-widest text-purple-600 hover:text-purple-700 transition-colors mt-auto"
              >
                {stat.cta}
                <SafeIcon icon={FiArrowRight} className="w-3 h-3 group-hover:translate-x-1 transition-transform" />
              </Link>
            </motion.div>
          );
        }

        return (
          <motion.div
            key={stat.label}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: idx * 0.1 }}
            className="bg-white p-6 rounded-[32px] border border-brand-dark shadow-sm hover:shadow-md transition-shadow group flex flex-col"
          >
            <div className={`w-12 h-12 ${stat.color} ${stat.textColor} rounded-2xl flex items-center justify-center mb-4 shadow-sm group-hover:scale-110 transition-transform`}>
              <SafeIcon icon={stat.icon} className="w-6 h-6" />
            </div>
            <h3 className="text-2xl font-serif text-accent-navy mb-1">{stat.value}</h3>
            <p className="text-[10px] font-black uppercase tracking-widest text-text-muted">{stat.label}</p>
          </motion.div>
        );
      })}
    </div>
  );
};

export default UserStatsOverview;